import { cn } from "@/lib/utils";

interface QuizStepperProps {
  currentStep: number;
  totalSteps: number;
  isInterstitial?: boolean;
  questionNumber?: number;
  interstitialNumber?: number;
}

export const QuizStepper = ({ 
  currentStep, 
  totalSteps, 
  isInterstitial = false,
  questionNumber,
  interstitialNumber 
}: QuizStepperProps) => {
  const progress = (currentStep / totalSteps) * 100;
  
  // Calculate estimated time remaining (total quiz is ~2 minutes = 120 seconds)
  const totalSeconds = 120;
  const remainingSeconds = Math.round(((totalSteps - currentStep) / totalSteps) * totalSeconds);
  
  const formatTime = (seconds: number) => {
    if (seconds >= 60) {
      const minutes = Math.round(seconds / 60);
      return `~${minutes} min`;
    }
    return `~${seconds} sek`;
  };
  
  return (
    <div className="w-full max-w-2xl mx-auto mb-8">
      <div className="flex justify-between items-center mb-3">
        <span className="text-sm font-medium text-muted-foreground">
          {formatTime(remainingSeconds)}
        </span>
        <div className="flex items-center gap-2">
          {/* Debug info */}
          <span className="text-xs font-mono text-muted-foreground/70 px-2 py-1 bg-muted/50 rounded">
            {isInterstitial 
              ? `Przerywnik ${interstitialNumber}` 
              : `Pytanie ${questionNumber}`}
          </span>
          <span className="text-sm font-medium text-primary">
            {Math.round(progress)}%
          </span>
        </div>
      </div>
      <div className="h-2 bg-secondary rounded-full overflow-hidden">
        <div 
          className="h-full bg-primary transition-all duration-500 ease-out"
          style={{ width: `${progress}%` }}
        />
      </div>
    </div>
  );
};
